
import { createSlice} from "@reduxjs/toolkit";
const GetProviderWorkersInvite = createSlice({
  name: 'GetProviderWorkersInvite',
      initialState:{
        data:null,
        loading:false,
        error:null,
    },
  reducers: {
    fetchData: (state) => {
      state.loading = true;
    },
    fetchDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    reSetData:()=>{
      return []
    }
  },
});
export const { fetchData, fetchDataSuccess, fetchDataError,reSetData } = GetProviderWorkersInvite.actions;
export default GetProviderWorkersInvite.reducer;